/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Link_Broken_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo found no meeting behind the link in your calendar. The invitation may still have an old link." |
*
* @param {Meeting_Notetaker_Issue_Link_Broken_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_link_broken_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Link_Broken_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Link_Broken_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo vond geen meeting achter de link in je agenda. Misschien staat er een oude link in de uitnodiging.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo n'a trouvé aucune réunion derrière le lien de votre agenda. L'invitation contient peut-être un ancien lien.")
	return /** @type {LocalizedString} */ ("Wundo found no meeting behind the link in your calendar. The invitation may still have an old link.")
});